import { FC, useEffect, useState } from "react";
import Logo from "../../../assets/images/logo.svg";
import BotLogo from "../../../assets/images/bot-logo.svg";
import { Box, FormControl, Stack, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useValidateTokenMutation } from "../../../services/auth";
import { useNavigate, useSearchParams } from "react-router-dom";
import React from "react";
import { errorToast, successToast } from "../../../utils/toast";
import { encryptAndStoreToken } from "../../../utils/tokenSecure";
import { useDispatch } from "react-redux";
import { setUser } from "../../../rtkSlices/metaDataSlice";

const currentYear = new Date().getFullYear();

const ValidateToken: FC = () => {
  const [validateToken, result] = useValidateTokenMutation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [token, setToken] = React.useState(searchParams.get("token"));
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  let validating = false;

  const getTokenValidated = async () => {
    validating = true;
    const response: any = await validateToken({ token });
    if (response.error) {
      setError(true);
      errorToast(
        response.error.error ||
          (response.error.data && response.error.data.message)
      );
    } else {
      setError(false);
      successToast("Welcome to HiiBo");
      encryptAndStoreToken(searchParams.get("access_token") || "");
      dispatch(setUser(response.data.result));
      navigate("/chat");
    }
  };

  React.useEffect(() => {
    if (!validating) {
      getTokenValidated();
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={BotLogo} alt="Logo" className="bot-logo" />
        <Grid
          container
          spacing={2}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid size={{ xs: 12, md: 12 }} textAlign={"center"}>
            <Typography color="secondary" fontSize={24}>
              {error ? (
                "Invalid token"
              ) : (
                <div>
                  Logging you in{" "}
                  <div style={{ display: "inline-block" }}>
                    <div
                      className={
                        theme.palette.mode == "dark"
                          ? "dark-loader"
                          : "light-loader"
                      }
                    ></div>
                  </div>
                </div>
              )}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <div className="copyright-div">
        <Typography className="copyright">
          © {currentYear} ALL RIGHTS RESERVED
        </Typography>
      </div>
    </>
  );
};

export default ValidateToken;
